import { AutomationService } from './automation.service';
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'automation',
  templateUrl: './automation.component.html'
})
export class AutomationComponent implements OnDestroy, OnInit {

  public selectedTab = "";

  public specNameEditMode = false;

  public specNameId = false;

  public registerSpinner: boolean = false;

  constructor(private appComponent: AppComponent, private automationService: AutomationService, private cdRef: ChangeDetectorRef) {

  }
  ngOnInit(): void {

    this.automationService.registerSpinner.asObservable().
      subscribe(value => {
        this.registerSpinner = value;
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges();
        }
      });
  }
  ngOnDestroy(): void {
    // this.appComponent.setSettingsSelected(false);
    this.automationService.registerSpinner.next(false);
  }
  tabSelected(tab) {
    this.specNameEditMode = false;
    this.specNameId = null;
    this.selectedTab = tab;
  }

  public changeToSpecNameEdit(data) {
    this.selectedTab = data.name;
    this.specNameEditMode = true;
    this.specNameId = data.specNameId;
  }

}



// WEBPACK FOOTER //
// ./src/app/automation/automation.component.ts